var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBoxListBigWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lgxf5wg9xa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8881",
    style: {
      fill: "none"
    },
    d: "M0 0h14.587v12.99H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8882",
    style: {
      fill: "none"
    },
    d: "M0 0h14.845v13H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1542"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1541",
    transform: "translate(.413)",
    style: {
      clipPath: "url(#lgxf5wg9xa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37126",
    d: "M.476 12.577A.479.479 0 0 1 0 12.1V.481A.479.479 0 0 1 .476 0h11.409a.479.479 0 0 1 .476.481V12.1a.479.479 0 0 1-.476.481zm.476-.962h10.457V.962H.952z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37127",
    d: "M43.355 43.421a.571.571 0 0 1-.363-.129.557.557 0 0 1-.1-.112l-.006-.009-.033-.032a.122.122 0 0 1-.016-.015l-1.948-2.361a.593.593 0 0 1 .075-.828.576.576 0 0 1 .819.075l1.563 1.9 2.681-3.392a.579.579 0 0 1 .456-.221.569.569 0 0 1 .363.129.593.593 0 0 1 .091.827L43.81 43.2a.578.578 0 0 1-.455.221",
    transform: "translate(-32.474 -30.431)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37128",
    d: "M11.327 14.849a.481.481 0 0 1 0-.962h6.328a.481.481 0 0 1 0 .962z",
    transform: "translate(-8.647 -11.036)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37129",
    d: "M11.327 29.254a.481.481 0 0 1 0-.962h6.328a.481.481 0 0 1 0 .962z",
    transform: "translate(-8.647 -22.484)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37130",
    d: "M11.327 43.548a.481.481 0 0 1 0-.962h4.405a.481.481 0 0 1 0 .962z",
    transform: "translate(-8.647 -33.844)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxListBigWhite);
export default __webpack_public_path__ + "static/media/icon_box_list_big_white.3f34db8497a3b357849c0c7b0bd6cce7.svg";
export { ForwardRef as ReactComponent };